export default [
	{
		path: "/client/team",
		exact: true,
		component: "Team",
		load: true,
	},
];
